import CalcDelivery from '../components/calc/CalcDelivery.svelte';
import CalcPainting from '../components/calc/CalcPainting.svelte';
import CalcPriceSimple from '../components/parts/PriceSimple.svelte';

let filter = ['profile-doors']; // не показываем эти для
let list = [];

if (filter.indexOf(APP_TYPE) === -1) {
    list.push({
        title: 'Покраска',
        calc: 'Покраска',
        img: '/img/paint.jpg',
        description: '',
        link: 'покраска',
        component: CalcPainting,
        components: [
            CalcPriceSimple,
        ],
    });
    
    list.push({
        title: 'Доставка',
        calc: 'Доставка',
        img: '/img/delivery.jpg',
        description: '',
        link: 'доставка',
        component: CalcDelivery,
        components: [
            CalcPriceSimple,
        ],
    });
}

export default list;
